// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_3x-0";